import { BaseRequest } from '@/typeDefine/HttpRequestType'
import CryptoJS from 'crypto-js'

export default class AES {

    public static readonly key: string = "key"
    public static readonly iv: string = "iv"

    private static readonly keyLength: number = 16

    /**
     * 加密明文
     * @param plainText 明文字符串
     * @returns base64 密文
     */
    public static encrypt(plain: BaseRequest[keyof BaseRequest], key: string, iv: string): string {

        if(typeof plain === null || typeof plain === 'undefined') {
            plain = 'null'
        }

        if (typeof plain === 'object') {
            plain = JSON.stringify(plain)
        }else {
            plain = plain.toString()
        }

        const encrypted = CryptoJS.AES.encrypt(plain, CryptoJS.enc.Base64.parse(key), {
            iv: CryptoJS.enc.Base64.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })

        return encrypted.toString()
    }

    /**
     * 解密密文
     * @param cipherText Base64编码的密文
     * @returns 解密后的原始明文字符串
     */
    public static decrypt(cipherText: string, key: string, iv: string): string {
        const decrypted = CryptoJS.AES.decrypt(cipherText, CryptoJS.enc.Base64.parse(key), {
            iv: CryptoJS.enc.Base64.parse(iv),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
        return decrypted.toString(CryptoJS.enc.Utf8)
    }

    public static generateBase64Key(): string {
        const key = CryptoJS.lib.WordArray.random(AES.keyLength)
        return CryptoJS.enc.Base64.stringify(key)
    }

    public static generateBase64IV(): string {
        const iv = CryptoJS.lib.WordArray.random(AES.keyLength)
        return CryptoJS.enc.Base64.stringify(iv)
    }
}
